import DiscountIcon from '@mui/icons-material/Discount'
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner'
import DnsIcon from '@mui/icons-material/Dns'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { Stack, Tab, Tabs, useTheme } from '@mui/material'
import * as React from 'react'

import {
  ClientBackendSettings,
  ClientDiscountSettings,
  ClientInfo,
  ClientTaxSettings,
} from '../client-info'
import { Printer } from '../printer'
import { ReceiptDesigner } from '../../libraries'
import { Receipt } from 'lucide-react'

const Settings = () => {
  const theme = useTheme()
  const [value, setValue] = React.useState(0)

  const tabContent = [
    <Stack key="profile">
      <ClientInfo />
    </Stack>,
    <Stack key="printer">
      <Printer />
    </Stack>,
    // <div key="display"><h2>Display Settings</h2></div>,
    <Stack key="tax-settings">
      <ClientTaxSettings />
    </Stack>,
    <Stack key="discount-settings">
      <ClientDiscountSettings />
    </Stack>,
    <Stack key="backend-settings" sx={{ width: "100%" }}>
      <ClientBackendSettings />
    </Stack>,
    <Stack key="receipt-designer" sx={{ width: "100%", height: "100%" }}>
      <ReceiptDesigner />
    </Stack>,
    // <Stack key="table-settings" flex={1}>
    //     <ClientTablesSettings />
    // </Stack>,
    // <Stack key="floor-settings" flex={1} style={{ height: "100%" }}>
    //     <FloorScreen />
    // </Stack>,
    // <Stack key="places-settings" flex={1} style={{ height: "100%" }}>
    //     <PlaceScreen />
    // </Stack>,
    // <Stack key="table-settings" flex={1} style={{ height: "100%" }}>
    //     <TablesScreen />
    // </Stack>,
    // <Stack key="floor-designer" flex={1} style={{ height: "100%" }}>
    //     <FloorDesigner />
    // </Stack>
  ]

  return (
    <Stack
      flexDirection={'row'}
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: '100%',
        pb: 10,
      }}
    >
      <Tabs
        value={value}
        onChange={(e, v) => setValue(v)}
        orientation="vertical"
        sx={{
          backgroundColor: theme.palette.background.default,
          maxWidth: 100,
          minWidth: 100,
          height: '100%',
        }}
      >
        <Tab
          icon={<ManageAccountsIcon fontSize="large" />}
          label="Profile"
          aria-label="Profile Settings"
        />
        <Tab
          icon={<LocalPrintshopIcon fontSize="large" />}
          label="Printer"
          aria-label="Printer Settings"
        />
        {/* <Tab icon={<PersonalVideoIcon fontSize='large' />} label="Display" aria-label="Display Settings" /> */}
        <Tab
          icon={<DocumentScannerIcon fontSize="large" />}
          label="Tax"
          aria-label="Tax Settings"
        />
        <Tab
          icon={<DiscountIcon fontSize="large" />}
          label="Discounts"
          aria-label="Discounts Settings"
        />
        <Tab
          icon={<DnsIcon fontSize="large" />}
          label="Servers"
          aria-label="Backend Server Settings"
        />
        <Tab
          icon={<Receipt fontSize="large" />}
          label="Receipt"
          aria-label="Receipt Designer"
        />
        {/* <Tab icon={<TableBarIcon fontSize='large' />} label="Tables" aria-label="Table Settings" /> */}
        {/* <Tab icon={<LandscapeIcon fontSize='large' />} label="Floors" aria-label="Floor Settings" />
                <Tab icon={<PlaceIcon fontSize='large' />} label="Places" aria-label="Place Settings" />
                <Tab icon={<TableBarIcon fontSize='large' />} label="Tables" aria-label="Table Settings" />
                <Tab icon={<TableBarIcon fontSize='large' />} label="Floor Designer" aria-label="Table Settings" /> */}
      </Tabs>
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        {tabContent[value]}
      </Stack>
    </Stack>
  )
}

export { Settings }
